<template>
  <button
    :style="{width: size, height: size}"
    class="add-event-btn"
    @click="$emit('click')"
  ></button>
</template>

<script>
export default {
  name: 'AddButtonSmall',
  props: {
    size: {
      type: String,
      default: '28px',
    },
  },
};
</script>

<style scoped>
  .add-event-btn {
    border: none;
    border-radius: 50%;
    background-image: url("../../assets/img/plus-button.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-color: var(--btn-primary);
    color: #FFFFFF;
    margin: auto 0;
    padding: 0;
  }
  .add-event-btn:focus {
      outline: none;
    }
</style>
